import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControlProps } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { get, indexOf, isEqual, merge, set } from 'lodash';

import { FormFieldProps } from 'modules/shared/Forms/types';
import { tripCommonTripSelector } from 'modules/common/CommonTrip/selectors';
import { Input } from 'modules/shared/Forms';
import YesNoModal from 'modules/shared/YesNoModal';
import { useModal } from 'modules/shared/hooks';
import { getTripSuccess } from 'modules/common/CommonTrip/actions';
import { ParamName } from 'entities/FillBtn';

type Props = {
  requestParamName?: ParamName;
  isMask?: boolean;
  isPosNumber?: boolean;
  isRequired?: boolean;
  isOptRequired?: boolean;
};

const TrackInput: React.FC<
  Props &
    FormControlProps &
    React.ClassAttributes<HTMLInputElement> &
    React.InputHTMLAttributes<HTMLInputElement> &
    FormFieldProps
> = React.memo(({ children, ...props }) => {
  const dispatch = useDispatch();
  const { isShow, openModal, closeModal } = useModal();

  const baseTrip = useSelector(tripCommonTripSelector);
  const baseNumber = get(baseTrip, props.name);
  const type = props.name.split('.')[0];

  const formik = useFormikContext();
  const number = get(formik.values, props.name);

  const onChangeDataDocs = () => {
    if (isEqual(type, 'driver') || isEqual(type, 'forwarder')) {
      const docs: any = get(formik.values, `${type}.documents`);
      const changesDoc = docs.find((d: any) => d.number === number);
      const index = indexOf(docs, changesDoc);

      changesDoc?.pictures.forEach((picture: any) => {
        set(picture, 'documentId', '0');

        // eslint-disable-next-line
        delete picture.id;
      });

      set(changesDoc, 'id', '0');
      merge(docs[index], changesDoc);

      merge(baseTrip, formik.values);
      set(baseTrip, `${type}.documents`, docs);

      // @ts-ignore
      dispatch(getTripSuccess(baseTrip));
    }

    if (isEqual(type, 'vehicle') || isEqual(type, 'trailer')) {
      const changesDoc: any = get(formik.values, `${type}.document`);

      changesDoc?.pictures.forEach((picture: any) => {
        set(picture, 'documentId', '0');

        // eslint-disable-next-line
        delete picture.id;
      });

      set(changesDoc, 'id', '0');

      merge(baseTrip, formik.values);
      set(baseTrip, `${type}.document`, changesDoc);

      // @ts-ignore
      dispatch(getTripSuccess(baseTrip));
    }
    closeModal();
  };

  const onDeleteDataDocs = () => {
    if (isEqual(type, 'driver') || isEqual(type, 'forwarder')) {
      const docs: any = get(formik.values, `${type}.documents`);
      const changesDoc = docs.find((d: any) => d.number === number);
      const index = indexOf(docs, changesDoc);

      set(changesDoc, 'id', '0');
      set(changesDoc, 'pictures', []);
      merge(docs[index], changesDoc);

      merge(baseTrip, formik.values);
      set(baseTrip, `${type}.documents`, docs);
      // @ts-ignore
      dispatch(getTripSuccess(baseTrip));
    }

    if (isEqual(type, 'vehicle') || isEqual(type, 'trailer')) {
      const changesDoc: any = get(formik.values, `${type}.document`);

      set(changesDoc, 'id', '0');
      set(changesDoc, 'pictures', []);

      merge(baseTrip, formik.values);
      set(baseTrip, `${type}.document`, changesDoc);
      // @ts-ignore
      dispatch(getTripSuccess(baseTrip));
    }
    closeModal();
  };

  useEffect(() => {
    if (
      !!baseNumber &&
      !!number &&
      baseNumber.trim().length &&
      number.trim().length &&
      !isEqual(number.trim(), baseNumber.trim())
    ) {
      if (isEqual(type, 'driver') || isEqual(type, 'forwarder')) {
        const docs: any = get(formik.values, `${type}.documents`);
        const changesDoc = docs.find((d: any) => d.number === number);

        if (changesDoc?.pictures?.length && !isEqual(`${changesDoc?.id}`, '0')) openModal();
      }

      if (isEqual(type, 'vehicle') || isEqual(type, 'trailer')) {
        const docs: any = get(formik.values, `${type}.document`);

        if (docs?.pictures?.length && !isEqual(`${docs?.id}`, '0')) openModal();
      }
    }
  }, [number]);

  return (
    <>
      <Input {...props}>{children}</Input>
      <YesNoModal
        isShow={isShow}
        title="Номер документа зміненно. Видалили відповідні фото"
        acceptHandler={onDeleteDataDocs}
        closeModal={onChangeDataDocs}
        closeHandler={() => {
          formik.setFieldValue(props.name, number);
          closeModal();
        }}
      />
    </>
  );
});

export default TrackInput;
